// extracted by mini-css-extract-plugin
export var dropdownContainer = "_pw-0";
export var leftAlign = "_pw-4";
export var listItem = "_pw-2";
export var listItemWrapper = "_pw-1";
export var operationText = "_pw-3";